// --- React & Redux
import React from 'react';
import { useSelector } from 'react-redux';
// --- Hooks & Utils
import { useAgGridApi } from 'datastage/components/AGGrid/hooks';
import { usePMXDeliveriesGridUtils } from './utils/gridUtils';
// --- UI Libraries
import DataGrid from '@dtci/spellbook/DataGrid';
// --- Styles
import styles from 'datastage/components/AGGrid/details-table.module.scss';

/**
 * PMX Deliveries Grid
 *
 * Features:
 * - Displays PMX deliveries in a data grid
 * - Integrates with Redux for deliveries state and filters
 * - Uses custom hooks for grid API and loading state
 * - Configures columns and sorting via utility hook
 *
 * @returns {JSX.Element}
 */
export const PMXDeliveriesGrid = () => {
    const agGridApi = useAgGridApi();
    const { deliveries } = useSelector((s) => s.pmxDeliveries);
    const showSpinner = useSelector((s) => s.spinner.showSpinner);

    const { columns } = usePMXDeliveriesGridUtils();

    return (
        <>
            <DataGrid
                className={styles.dataGrid}
                autoSizing
                agGrid={{
                    ref: agGridApi.AgGridApiRef,
                    rowData: deliveries,
                    headerHeight: 45,
                    defaultColDef: {
                        wrapText: true,
                        autoHeight: true,
                        suppressMenu: true,
                        resizable: true,
                        cellStyle: { 
                            paddingTop: '10px', 
                            paddingBottom: '10px',
                            wordBreak: 'normal',
                            overflowWrap: 'break-word',
                        },
                    },
                }}
                bordered="none"
                columnDefs={columns}
                sortable={false}
                striped
                noResultsMessage={showSpinner ? 'Loading...' : 'No PMX deliveries Found'}
            />
        </>
    );
};
